import type {
  RailwayProjectContext,
  RailwayRunner,
  RailwayService
} from '@cli-types/next-adapter/railway.js'
import { linkRailwayProject } from './link-railway-project.js'

export async function linkRailwayService(
  runner: RailwayRunner,
  cwd: string,
  project: RailwayProjectContext,
  service: RailwayService,
  env?: NodeJS.ProcessEnv
): Promise<void> {
  await linkRailwayProject(runner, cwd, project.id, project.environmentName, {
    service: service.id,
    env
  })
}
